export default {
  payment: 'nạp điện',
  order: 'Đơn hàng',
  paymentMethod: 'phương thức thanh toán',
  choosePaymentMethod: 'tùy chọn',
  moreOptions: 'Nhiều phương thức nạp tiền hơn',
  bank: 'ngân hàng',
  name: 'Tên',
  enterCardOwnerName: 'Nhập tên chủ thẻ của thẻ thanh toán của bạn',
  phoneNumber: 'Số điện thoại di động',
  enterYourCardPhoneNumber: 'Nhập số điện thoại di động của thẻ thanh toán của bạn',
  lowest: 'thấp nhất',
  highest: 'Cao nhất',
  rmb: 'Nhân dân tệ',
  point: 'tích phân',
  enterCustomAmount: 'Nhập số tiền tùy chỉnh',
  payAmount: 'Số tiền thanh toán',
  cardNumber: 'số thẻ',
  enterCardNumber: 'Vui lòng nhập số thẻ thanh toán',
  payImmediately: 'thanh toan ngay',
  have: 'có',
  personSuccess: 'người đã nạp tiền thành công',
  channelUnavailable: 'Không có kênh nào',
  paymentType: 'Phương thức thanh toán',
  orderUnavailable: 'đơn đặt hàng không tồn tại',
  error: 'sai lầm',
  requestAgain: 'Đơn hàng đã tồn tại, vui lòng thử lại',
  orderNumber: 'số thứ tự',
  enterCardOwner: 'Vui lòng nhập tên của thẻ ngân hàng thanh toán',
  enterRealName: 'vui lòng nhập tên thật của bạn',
  enterPhone: 'xin vui lòng điền số điện thoại của bạn',
  enterAnInteger: 'Vui lòng nhập một số nguyên',
  paymentSupport: 'Hỗ trợ nạp tiền',
  requestTooFrequently: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
  needToSlowlyRequest: 'Xin lỗi, vì bạn đã thường xuyên đặt hàng nhưng không gửi thanh toán',
  waitFiveMinutes: 'Hãy nghỉ ngơi trong năm phút và thử lại, cảm ơn bạn đã hợp tác',
  done: 'Kết thúc',
  chooseLanguage: 'Chọn ngôn ngữ',
  en: 'Tiếng Anh',
  vn: 'Tiếng Việt',
  cn: 'Tiếng Trung giản thể',
  tw: 'truyền thống Trung Quốc',
  copy: 'sao chép',
  tips: 'dấu',
  scanQrcode: 'Quét Qrcode hoặc nhấp để sao chép địa chỉ',
  screenshotAndScript: 'Để tìm số theo dõi, vui lòng cung cấp ảnh chụp màn hình và mã tái bút',
  orderInfo: 'Thông tin đặt hàng',
  address: 'Địa chỉ',
  scripts: 'tái bút',
  qrcode: 'Quét mã',
  ipBlock: 'Bạn đã bị chặn, vui lòng liên hệ với cấp trên của bạn',
  invalidName: 'Không xác thực tên thật',
  paid: 'thanh toán thành công',
  channelMaintain: 'Kênh đang được bảo trì, vui lòng liên hệ bộ phận chăm sóc khách hàng',
  id_number: 'số CMND',
  phone: 'Số điện thoại',
  fixWrong: 'vui lòng sửa lỗi',
  formatWrong: 'không chính xác',
  mobilePlaceholder: 'điền số điện thoại di động của bạn (e.g. 254123456789)'
}



// WEBPACK FOOTER //
// ./src/locales/lang/vn.js